import * as React from 'react'

import { Box, Button, Icon } from '@factorialco/deprecated-design-system'
import { useField } from 'formik'
import type { ExportsExporterQuery } from 'generated/resources/graphql'

import DropdownSearchBar from 'modules/core/components/DropdownSearchBar'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { FormField } from 'modules/universal_exports/components/ExportSidepanel/types'

type UniversalExportsExporterField =
  ExportsExporterQuery['universalExports']['exportersConnection']['nodes'][number]['fields'][number]

interface Props {
  name: string
  defaultLabel?: string
  options: UniversalExportsExporterField[]
  onDelete: () => void
}

const FieldRow = ({ name, defaultLabel, options, onDelete }: Props) => {
  const [_, { value }, { setValue }] = useField<FormField>(name)

  return (
    <Box
      flexDirection="column"
      border={{ bottom: { color: 'grey400', width: 's1', style: 'solid' } }}
    >
      <Box flexDirection="row" gap="s8">
        <Box cursor="pointer" justifyContent="center" flexNoShrink>
          <Icon.Medium icon="drag-and-drop" />
        </Box>
        <Box
          flexDirection="row"
          style={{ width: 'auto', marginBottom: '18px', marginTop: '18px' }}
          gap="s8"
        >
          <Box width="full">
            <DropdownSearchBar
              name={defaultLabel ?? ''}
              data={options.map((o) => ({ label: o.label, value: o.name }))}
              label=""
              labelNotFound={i18n.t('universal_exports.config.fields.not_found')}
              searchLabel={i18n.t('common.search')}
              sortLabel={i18n.t('common.name')}
              placeholder={i18n.t('universal_exports.config.fields.select')}
              selectLabel={i18n.t('universal_exports.config.fields.select')}
              disabled={options.length == 0}
              autofocus={false}
              onSelect={(item) => setValue({ name: String(item.value), label: '' })}
            />
          </Box>
          <Box justifyContent="center" flexNoShrink>
            <Icon.Medium icon="chevron-right" />
          </Box>
          <Box width="full">
            <TextField
              type="text"
              value={value.label}
              placeholder={i18n.t('universal_exports.config.fields.placeholder')}
              onChange={(label) => setValue({ ...value, label })}
              hideError
            />
          </Box>
        </Box>
        <Box paddingY="s12" alignItems="center" alignSelf="center">
          <Button onClick={onDelete} type="secondary" iconName="remove" />
        </Box>
      </Box>
    </Box>
  )
}

export default FieldRow
